export default {
  root: {
    '& th': {
      borderBottom: '1px solid #DFE3E8',
      fontWeight: 'bold',
    },
  }
};
